"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Extensions {
}
Extensions.PROJECT_EXTENSION = 'eproj';
Extensions.FORM_EXTENSION = 'efrm';
Extensions.APP_FORM_EXTENSION = 'eaf';
Extensions.FLOW_EXTENSION = 'eflw';
Extensions.FOLDER_EXTENSION_1 = '';
Extensions.FOLDER_EXTENSION_2 = 'folder';
Extensions.REPORT_DESIGNER_EXTENSION = 'rpt';
Extensions.MSSQL_QUERY = 'mssqlds';
Extensions.ORACLE_QUERY = 'oracleds';
Extensions.MYSQL_QUERY = 'mysqlds';
Extensions.ODBC_QUERY = 'odbcds';
Extensions.POST_GRE_QUERY = 'postgreds';
Extensions.WEBSERVICE_QUERY = 'webserviceds';
Extensions.REST_QUERY = 'restds';
Extensions.SAP_QUERY = 'saprfc';
Extensions.ERP_QUERY = 'erpds';
Extensions.GPT_QUERY = 'gptds';
Extensions.CSS__EXTENSION = 'css';
Extensions.HTML__EXTENSION = 'html';
Extensions.TS__EXTENSION = 'ts';
Extensions.TSX__EXTENSION = 'tsx';
Extensions.JS__EXTENSION = 'js';
Extensions.JSX__EXTENSION = 'jsx';
Extensions.SCSS__EXTENSION = 'scss';
Extensions.TXT__EXTENSION = 'txt';
Extensions.IMAGE_PNG_EXTENSION = 'png';
Extensions.IMAGE_JPG_EXTENSION = 'jpg';
Extensions.IMAGE_JPEG_EXTENSION = 'jpeg';
Extensions.IMAGE_GIF_EXTENSION = 'gif';
Extensions.SCHEDULER = 'sch';
exports.default = Extensions;
//# sourceMappingURL=Extensions.js.map